import { z } from 'zod';
import {
  auditFieldsShape,
  localDateTimeSchema,
  softDeleteShape,
  utcTimestampSchema,
  uuidSchema,
} from './primitives';

export const FOLLOW_UP_CHANNELS = [
  'in_person',
  'phone',
  'email',
  'message',
  'meeting',
  'other',
] as const;
export const followUpChannelSchema = z.enum(FOLLOW_UP_CHANNELS);

export const followUpLogSchema = z.object({
  id: uuidSchema,
  taskId: uuidSchema,
  occurredAtLocal: localDateTimeSchema,
  contactIds: z.array(uuidSchema),
  channel: followUpChannelSchema,
  summary: z.string(),
  response: z.string().nullable(),
  nextFollowUpAtLocal: localDateTimeSchema.nullable(),
  /** 由主管提醒自動產生時指向來源提醒；手動建立時為 null。 */
  supervisorReminderId: uuidSchema.nullable(),
  ...softDeleteShape,
  ...auditFieldsShape,
});

export const REMINDER_STATES = ['pending', 'snoozed', 'done', 'cancelled'] as const;
export const reminderStateSchema = z.enum(REMINDER_STATES);

export const REMINDER_CHANNELS = [
  'in_person',
  'phone',
  'message',
  'email',
  'meeting',
  'other',
] as const;
export const reminderChannelSchema = z.enum(REMINDER_CHANNELS);

export const supervisorReminderSchema = z.object({
  id: uuidSchema,
  taskId: uuidSchema,
  supervisorContactId: uuidSchema,
  remindAtLocal: localDateTimeSchema,
  message: z.string(),
  channel: reminderChannelSchema,
  state: reminderStateSchema,
  snoozedUntilLocal: localDateTimeSchema.nullable(),
  completedAt: utcTimestampSchema.nullable(),
  /** 有值即代表本次提醒的後續處理已詢問過，不再重複跳出。 */
  followUpPromptDismissedAt: utcTimestampSchema.nullable(),
  ...auditFieldsShape,
});

export type FollowUpChannel = z.infer<typeof followUpChannelSchema>;
export type FollowUpLog = z.infer<typeof followUpLogSchema>;
export type ReminderState = z.infer<typeof reminderStateSchema>;
export type ReminderChannel = z.infer<typeof reminderChannelSchema>;
export type SupervisorReminder = z.infer<typeof supervisorReminderSchema>;
